// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__1Apux","col":"styles_col__39gM6"};